module.exports = __webpack_public_path__ + "static/media/type.5c8c33c2.jpg";